package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_03_21_Day_1
import com.veldekar.components.logs.Log_2026_03_21_Day_2
import com.veldekar.components.logs.Log_2026_03_21_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-03-21")
@Composable
public fun Log_2026_03_21(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Highridge Intruder",
        ogTitle = "Highridge Intruder",
        date = LocalDate(2_026, 3, 21),
        aiHint = "Image, title, and description reference 'Bed Intruder' meme.",
        ogDescription = "Well, obviously we have a demon in Highridge. He’s climbin’ in your windows, he’s snatchin’ your people up, tryin’ to corrupt ‘em. So y’all need to hide your kids, hide your wife, and hide your husband cause they’re grabbin’ everybody out here.",
        ogImage = "images/highridgeIntruder.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn map of Highridge (with a demon superimposed on top of it) and Kostigan next to an illustration of an angry man with a red bandana. This is a reference to the \"bed intruder\" meme.",
    ) {
        SessionDayHeader(dayId = "shimmer-20", dateString = "Shimmer 20")
        Log_2026_03_21_Day_1()
        SessionDayHeader(dayId = "shimmer-21", dateString = "Shimmer 21")
        Log_2026_03_21_Day_2()
        SessionDayHeader(dayId = "shimmer-22", dateString = "Shimmer 22")
        Log_2026_03_21_Day_3()
        SessionMediaItem(
            image = "images/highridgeIntruder.webp",
            linkImage = "images/highridgeIntruder.webp",
            description = "A hand-drawn map of Highridge (with a demon superimposed on top of it) and Kostigan next to an illustration of an angry man with a red bandana. This is a reference to the \"bed intruder\" meme.",
            width = 1_200,
            height = 630,
        )
    }
}
